"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../values/colors/colors");
var fonts_1 = require("../values/fonts/fonts");
var Wrapper = styled_components_1.default("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nbackground-color: ", ";\nborder: ", ";\nfont: ", ";\ncolor: ", ";\nheight: ", ";\npadding: ", ";\nborder-radius: 50px;\ntext-align: center;\nuser-select: none;\ndisplay: inline-flex;\njustify-content: center;\nalign-items: center;\nposition: relative;\n&:hover{\n    cursor: ", ";\n    background-color: ", ";\n    color: ", ";\n    border: 2px solid ", "\n};\n"], ["\nbackground-color: ",
    ";\nborder: ",
    ";\nfont: ", ";\ncolor: ",
    ";\nheight: ", ";\npadding: ", ";\nborder-radius: 50px;\ntext-align: center;\nuser-select: none;\ndisplay: inline-flex;\njustify-content: center;\nalign-items: center;\nposition: relative;\n&:hover{\n    cursor: ", ";\n    background-color: ",
    ";\n    color: ",
    ";\n    border: 2px solid ",
    "\n};\n"])), function (props) { return props.disabled ? colors_1.grey :
    props.secondary ? "" :
        props.dark ? colors_1.dark :
            props.light ? colors_1.white :
                props.warning ? colors_1.red :
                    colors_1.primary; }, function (props) { return props.disabled ? "2px solid " + colors_1.grey :
    props.secondary ? "2px solid " +
        (props.dark ? colors_1.dark :
            props.light ? colors_1.white :
                props.warning ? colors_1.red :
                    colors_1.primary)
        : "2px solid " +
            (props.dark ? colors_1.dark :
                props.light ? colors_1.white :
                    props.warning ? colors_1.red :
                        colors_1.primary); }, function (props) { return props.small ? fonts_1.primaryFont.medium : fonts_1.primaryFont.large; }, function (props) { return props.disabled ? colors_1.darkenGrey :
    props.secondary ?
        props.dark ? colors_1.dark :
            props.light ? colors_1.white :
                colors_1.primary
        :
            props.dark ? colors_1.white :
                props.light ? colors_1.dark :
                    colors_1.white; }, function (props) { return props.small ? "24px" : "36px"; }, function (props) { return props.small ? "0 12px" : "0 24px"; }, function (props) { return props.disabled ? "default" : "pointer"; }, function (props) { return props.disabled ? colors_1.grey :
    props.secondary ?
        props.dark ? colors_1.dark :
            props.light ? colors_1.white :
                props.warning ? colors_1.red :
                    colors_1.primary
        :
            props.dark ? colors_1.lightDark :
                props.light ? colors_1.darkenWhite :
                    props.warning ? colors_1.darkenRed :
                        colors_1.darkenPrimary; }, function (props) { return props.disabled ? colors_1.darkenGrey :
    props.secondary ?
        props.dark ? colors_1.white :
            props.light ? colors_1.dark :
                colors_1.white
        : ""; }, function (props) { return props.disabled ? colors_1.grey :
    props.secondary ?
        props.dark ? colors_1.dark :
            props.light ? colors_1.white :
                props.warning ? colors_1.red :
                    colors_1.primary
        :
            props.dark ? colors_1.lightDark :
                props.light ? colors_1.darkenWhite :
                    props.warning ? colors_1.darkenRed :
                        colors_1.darkenPrimary; });
exports.Button = function (props) { return (React.createElement(Wrapper, { id: props.id, small: props.small, disabled: props.disabled, light: props.light, dark: props.dark, warning: props.warning, secondary: props.secondary, onClick: function (e) {
        if (props.disabled)
            return;
        props.onClick(e);
    } }, props.children)); };
var templateObject_1;
//# sourceMappingURL=Button.js.map